module.exports = __webpack_public_path__ + "media/images/phone-whatapp-image-b9b48b7d9094aacdbbd5d24bc2cd7674.png";